<template>
  <div>
    <el-checkbox :value="alibabaForm[key]" true-label="1" false-label="0" @change="onChange">{{ label }}</el-checkbox>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      isHasOptionsComp: true,
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    label() {
      return this.props.dataSource.label || '未知';
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateAlibabaForm(newFormFields);
    },
  },
};
</script>
